module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.post) ? _c('section', {
    staticClass: "post"
  }, [_c('post-list', {
    staticClass: "post__list",
    attrs: {
      "prevent-nav": !_vm.showPost
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "post__scrollbox"
  }, [_c('transition', {
    attrs: {
      "name": "swap"
    }
  }, [_c('article', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showPost),
      expression: "showPost"
    }],
    ref: "post",
    staticClass: "post__content"
  }, [_c('h1', {
    staticClass: "post__title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('time', {
    staticClass: "post__published"
  }, [_vm._v(_vm._s(_vm.published))]), _vm._v(" "), _c('figure', {
    staticClass: "post__feature"
  }, [(_vm.post.image) ? _c('img', {
    staticClass: "post__image",
    attrs: {
      "src": _vm.post.image.url,
      "alt": _vm.post.image.alt
    }
  }) : _vm._e(), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": ("/blogue/categorie/" + (_vm.post.category))
    }
  }, [_c('icon', {
    staticClass: "post__category",
    class: ("post__category--" + (_vm.post.category)),
    attrs: {
      "id": _vm.post.category
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "post__body rte"
  }, _vm._l((_vm.post.text), function(item) {
    return _c(item.component, {
      key: item,
      tag: "component",
      attrs: {
        "item": item
      }
    })
  })), _vm._v(" "), _c('footer', [(_vm.author) ? _c('div', {
    staticClass: "post__footer author author--post"
  }, [_c('img', {
    staticClass: "author__photo",
    attrs: {
      "src": _vm.author.photo.url,
      "alt": _vm.author.photo.alt
    }
  }), _vm._v(" "), _c('div', [_c('h4', {
    staticClass: "author__name"
  }, [_vm._v(_vm._s(_vm.author.name))]), _vm._v(" "), _c('h5', [_vm._v(_vm._s(_vm.author.title))])])]) : _vm._e(), _vm._v(" "), _c('newsletter-form', {
    staticClass: "post__footer",
    attrs: {
      "content": {
        title: _vm.blog.newsletter,
        submit: _vm.blog.submit,
        placeholder: 'Courriel'
      }
    }
  }), _vm._v(" "), _c('suggested-posts', {
    staticClass: "post__footer",
    attrs: {
      "post": _vm.post,
      "count": 3,
      "title": _vm.blog.suggested
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "disqus"
  }, [(_vm.showComments) ? _c('vue-disqus', {
    key: _vm.uid,
    attrs: {
      "shortname": "spk-blog",
      "identifier": _vm.uid,
      "url": ("https://www.spk.rocks/blogue/" + _vm.uid)
    }
  }) : _vm._e()], 1)], 1)])])], 1), _vm._v(" "), _c('button', {
    staticClass: "post__back",
    class: _vm.backClass,
    on: {
      "click": _vm.navBack
    }
  })], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0d9401ba!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/blog/BlogPost.vue
// module id = 624
// module chunks = 1